const baseUrl = `${process.env.VUE_APP_ZEYOS_PLATFORM}/remotecall/calidore.core.api`;
const shopDomain = process.env.VUE_APP_SHOP_DOMAIN

const config = {
  placeOrderTermsOfService: '',
  theme: 'light',
  documentTitle: 'Officemaker',
  title: 'Officemaker',
  logo: require('../assets/logo.jpg'),
  backToOriginButton: {
    label: {
      en: 'Back to Shop',
    },
    url: `https://${shopDomain}/`,
  },
  languages: [{
    value: 'en',
    label: 'English',
    img: require('../core/assets/flag-en.svg'),
  }],
  initial: {
    isExistingCustomer: 'n',
    validAccount: true,
    accountStatus: '',
    error: null,
  },
  defaultLanguage: 'en',
  events: {
    async onSubmit(form, formdata) {
      let response;

      let commentSections = '';
      if (form.comments && form.comments.trim() !== '') {
        commentSections = `
          <br/>
          COMMENTS <br/>
          <p>${form.comments}</p>
        `;
      }

      const body = {
        subject: `Request for registration from User: ${form.firstname} ${form.lastname}`,
        html: `
          <div>
            EMAIL: ${form.email} <br/>
            NAME: ${form.firstname} ${form.lastname} <br/>
            COMPANY: ${form.company} <br/>
            DATA: ${JSON.stringify(form, null, 2)} <br/>
            ${commentSections}
          </div>
        `
      }

      response = await fetch(`${baseUrl}/sendmail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })

      if (response.ok) {
      } else {
        throw new Error(`Submission failed`);
      }
    },
  },
  submit: {
    label: {
      en: 'Submit'
    },
    title: {
      en: 'Thank you for registering with us',
    },
    description: {
      en: 'Your request is now being reviewed by our team. We’ll notify you as soon as your account is activated.',
    },
  },
  tabs: [
    {
      label: {
        en: 'Contact details',
      },
      id: 'masterdata',
      sections: [
        {
          type: 'html',
          content: {
            en: '<h1 style="text-align: center; margin-bottom: 80px; font-size: 18px;">This form submits an account request for access to our online shop. A member of our team will review your details and activate your account</h1>',
          }
        },
        {
          type: 'form',
          cols: 2,
          label: {
            en: 'Please enter your contact details',
          },
          fields: [
            {
              id: 'title',
              label: {
                en: 'Title',
              },
              type: 'select',
              required: false,
              options: [
                {
                  label: { en: 'Ms' },
                  value: 'Ms'
                },
                {
                  label: { en: 'Miss' },
                  value: 'Miss'
                },
                {
                  label: { en: 'Mr' },
                  value: 'Mr'
                },
                {
                  label: { en: 'Dr.' },
                  value: 'Dr'
                },
                {
                  label: { en: 'Prof.' },
                  value: 'Prof'
                },
              ]
            },
            {
              id: 'firstname',
              label: {
                en: 'Firstname',
                de: 'Vorname'
              },
              type: 'text',
              required: true
            },
            {
              id: 'lastname',
              label: {
                en: 'Lastname',
                de: 'Nachname'
              },
              type: 'text',
              required: true
            },
          ]
        },
        {
          type: 'form',
          cols: 2,
          label: {
            en: 'Business address',
          },
          fields: [
            {
              id: 'company',
              label: {
                en: 'Company name',
              },
              type: 'text',
              required: true
            },
            {
              id: 'country',
              label: {
                en: 'Country',
              },
              type: 'select',
              required: true,
              options: require('./countries.js')
            },
            {
              id: 'street',
              label: {
                en: 'Street',
              },
              type: 'text',
              required: true
            },
            {
              id: 'streetno',
              label: {
                en: 'Street no',
              },
              type: 'text',
              required: true
            },
            {
              id: 'postcode',
              label: {
                en: 'Post Code',
              },
              type: 'text',
              required: true
            },
            {
              id: 'city',
              label: {
                en: 'City',
              },
              type: 'text',
              required: true
            },
            {
              id: 'email',
              label: {
                en: 'E-mail',
              },
              type: 'email',
              required: true
            },
            {
              id: 'phone',
              label: {
                en: 'Phone',
              },
              type: 'phone',
              required: true
            }
          ]
        }, {
          type: 'form',
          cols: 1,
          label: {
            en: 'Comments',
          },
          fields: [
            {
              id: 'comments',
              label: {
                en: 'Comments',
              },
              type: 'textarea'
            }
          ]
        }
      ],
    }
  ]
}

export default config;
